import { Injectable, Type } from '@angular/core';
import { Subject } from 'rxjs';
import { WidgetItem } from '../shared-datatypes/widget-items';
import { DataService } from '../shared-service/data.service';
import { BaseService }   from '../shared-service/base.service';
import { WindowRef } from '../shared-service/windowRef.service';

@Injectable()
export class SharingPanelService {

    compList: object | any = {};
    treeData: object | any = {};
    changeDetected = new Subject<string>();
    sharedSuccess = new Subject<boolean>();
	activeWallSubject = new Subject<boolean>();
	isActiveWall: boolean = false;

    constructor(private ds: DataService, private bs: BaseService,private winRef:WindowRef) {
    	this.compList['panel'] = { initializing: true };
		this.activeWallSubject.next(this.isActiveWall);
    }

	updateActiveWall(isActiveWall: boolean): void{
		this.isActiveWall = isActiveWall;
		this.activeWallSubject.next(this.isActiveWall);
	}

    updateComponentObj( component: Type<any>, data: object ) {		
        this.compList['panel'] = new WidgetItem(component, data);
    }

    resetPanel() {
    	this.compList['panel'] = { initializing: true };
    }

    GetShareTreeJson(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'OverView/GetShareTreeJson', body).then((data) => {
				resolve(data);
			}, (err) => {
				reject(err);
			});
		});
	}

	

	getUserList(body: Object, key: PropertyKey, useFor: string) {
		let cm = '';
		if (useFor == 'SharingPanelComponent') {
			cm = 'OverView/GetUserList';
		} else if (useFor == 'BriefcaseListComponent' || useFor == 'BriefcaseDetailsComponent' || useFor == 'MyBriefcaseComponent') {
			cm = 'learning/GetUserList';
		}
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, cm, body).then((data) => {
				resolve(data);
			}, (err) => {
				reject(err);
			});
		});
	}

	ShareTimeLineTiles(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'OverView/ShareTimeLineTiles', body).then((data) => {
				resolve(data);
			}, (err) => {
				reject(err);
			});
		});
	}

	setBlockShareTimeLineTilesUser(body: Object, key: PropertyKey) {
		return new Promise((resolve, reject) => {
			this.ds.doPostWithPromise(key, 'OverView/BlockShareTimeLineTilesUser', body).then((data) => {
				resolve(data);
			}, (err) => {
				reject(err);
			});
		});
	}
selectedItems: string = '';

	refreshList() {
		this.selectedItems = '';
		let rootObj = this.treeData['data'];
		let el = this.winRef.nativeWindow.document.getElementById(this.treeData['rootId']);
		let inputAr = el!.getElementsByTagName('input');
		for (var i = 0; i < inputAr.length; i++) {
			if(inputAr[i]['checked']) {
				let arrRoute = inputAr[i]['value'].split('-');
				if (arrRoute[0] == 'true') {
					let nEl = this.winRef.nativeWindow.document.getElementById('ul'+arrRoute[1]+this.treeData['rootId']);
					this.selectedItems = this.selectedItems + arrRoute[1] + ',';
					if (nEl == null) {
						this.findChilds(arrRoute, rootObj);
					}
				} else {
					this.selectedItems = this.selectedItems + arrRoute[1] + ',';
				}
			}
		}
		return this.selectedItems;
	}

	findChilds(arrRoute: Array<string>, rootObj: object | any) {
		let tmpObj = rootObj;
		for (let i = 3; i < arrRoute.length; i++) {
			tmpObj = tmpObj['childs'][arrRoute[i]];
		}
		this.doAddIds(tmpObj);
	}

	doAddIds(tmpObj:any) {
		if (tmpObj['childs'] != null) {
			for (let i = 0; i < tmpObj['childs'].length; i++) {
				this.selectedItems = this.selectedItems + tmpObj['childs'][i]['id'] + ',';
				this.doAddIds(tmpObj['childs'][i]);
			}
		}
	}

	/*findParentPath(arrRoute: Array<string>) {
		let tmpObj = this.rootObj;
		for (let i = 3; i < arrRoute.length; i++) {
			tmpObj = tmpObj['childs'][arrRoute[i]];
			this.selectedItems = this.selectedItems + tmpObj['id'] + ',';
		}
	}*/
}